// @module Tekyard.PDPSerialLotFunctionality.SerialLotData
define('C3.PDPSerialLotFunctionality.SerialLotData.MainView'
,	[
	'tekyard_pdpseriallotfunctionality_seriallotdata_mainview.tpl'
	
	,   'C3.PDPSerialLotFunctionality.SerialLotData.CarouselItems'
	,	'Backbone'
	,   'Utils'
	,   'jQuery'
    ]
, function (
	tekyard_pdpseriallotfunctionality_seriallotdata_mainview_tpl

	,   SerialLotCarouselItems
	,	Backbone
	,   Utils
	,   jQuery
)
{
    'use strict';

	// @class Tekyard.PDPSerialLotFunctionality.SerialLotData.View @extends Backbone.View
	return Backbone.View.extend({

		template: tekyard_pdpseriallotfunctionality_seriallotdata_mainview_tpl

	,	initialize: function (options) {	
			this.options = options;	
			this.application = options.application;
			this.layout = options.layout;
			this.item = options.item;	
			//this.qty = options.qty;	
			this.selectedFunctional = options.selectedFunctional;
			this.selectedCosmetic = options.selectedCosmetic;
			this.functionalConditions = options.functionalConditions;
			this.cosmeticConditions = options.cosmeticConditions;
			this.filteredInventory = options.filteredInventory;	
		}

	,   modalClass: 'pdp-serial-number-lightbox-modal'		

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			'SerialLot.CarouselItems': function () {
				const functionalname = this.functionalConditions.find(item => item.default === true);
				const cosmeticname = this.cosmeticConditions.find(item => item.default === true);
				//console.log(cosmeticname)
				return new SerialLotCarouselItems({
                   functional: this.selectedFunctional,
                   functionalname : functionalname,
                   cosmetic : this.selectedCosmetic,
                   cosmeticname : cosmeticname,
                   item : this.item,
                   application : this.application,
                   layout : this.layout,
                   functionalConditions : this.functionalConditions,
				   cosmeticConditions : this.cosmeticConditions,
				   filteredInventory : this.filteredInventory,
				   parentView : this
                });
		    }
		}

	,   destroy: function destroy() {
			// Remove any Bootstrap tooltips left in <body> when the modal closes
			jQuery('body > .tooltip').remove();
			Backbone.View.prototype.destroy.apply(this, arguments);
		}

		//@method getContext @return Tekyard.PDPSerialLotFunctionality.SerialLotData.View.Context
	,	getContext: function getContext()
		{
			
			//const quantityOptions = Array.from({ length: this.qty }, (_, i) => i + 1);
			//console.log(this)
			return {
				isPhoneDevice : Utils.isPhoneDevice()
			};
		}
	});
});
